<script>

import FiltersPanel from "@/components/filters/FiltersPanel.vue";
import TokenTransactionsFilterPanel from "@/components/tokenTransactions/TokenTransactionsFilterPanel.vue";
import { useTokenTransactionDownloads } from "@/composables/useTokenTransactionDownloads.js";
import DownloadConfirmationsPanel from "@/components/tokenTransactions/DownloadConfirmationsPanel.vue";
import TokenTransactionsTable from "@/components/tokenTransactions/TokenTransactionsTable.vue";

export default {
    components: {
        TokenTransactionsTable,
        DownloadConfirmationsPanel, TokenTransactionsFilterPanel, FiltersPanel},
    setup() {
        const { download } = useTokenTransactionDownloads();

        return {
            download
        };
    },
    data() {
        return {
            error: '',
            loading: true,
            downloading: false,
            transactions: [],
            meta: {
                current_page: 1,
                total: 0,
                per_page: 0,
            },
            controller: {
                data: null,
                companies: null
            },
            companies: [],
            loadingCompanies: true,
            companyId: null,
            filters: {},
            selectionMode: false,
            selectedIds: [],
            perPage: parseInt(localStorage.getItem('perPage_employerTransactions') || '10'),
        }
    },
    methods: {
        onChangeSelectionMode() {
            this.selectionMode = !this.selectionMode;
            if (!this.selectionMode) {
                this.selectedIds = [];
            }
        },
        onFiltersChange(filters) {
            this.filters = filters;
            this.meta.current_page = 1;
            this.loadData();
        },
        onToggleRow(transaction) {
            const idx = this.selectedIds.indexOf(transaction.id);
            if (idx !== -1) {
                this.selectedIds.splice(idx, 1);
            } else {
                this.selectedIds.push(transaction.id);
            }
        },
        loadData() {
            if (this.controller.data) {
                this.controller.data.abort();
            }
            this.controller.data = new AbortController();
            this.loading = true;
            window.scrollTo({top: 0});
            let params = {
                page: this.meta.current_page,
                per_page: this.perPage,
                employers: 1,
                filters: this.filters
            };
            if (this.companyId) {
                params.company_id = this.companyId;
            }
            axios.get('/token-transactions', {
                signal: this.controller.data.signal,
                params: params
            }).then(response => {
                this.transactions = response.data.data;
                this.meta.current_page = response.data.meta.current_page;
                this.meta.total = response.data.meta.total;
                this.meta.per_page = response.data.meta.per_page;
            }).finally(() => {
                this.loading = false;
            })
        },
        onPageChange(page) {
            this.controller.data.abort();
            this.meta.current_page = page;
            this.loadData();
        },
        loadCompanies() {
            if (this.controller.companies) {
                this.controller.companies.abort();
            }
            this.controller.companies = new AbortController();
            this.loadingCompanies = true;
            axios.get('/companies',{
                signal: this.controller.companies.signal
            }).then(response => {
                this.companies = response.data.data;
            }).catch(error => {
            }).finally(() => {
                this.loadingCompanies = false;
            })
        },
        onPerPageChange(val) {
            this.perPage = val;
            this.meta.current_page = 1;
            this.loadData();
        },
        downloadXlsx() {
            this.downloading = true;
            let params = {
                employers: 1,
                filters: this.filters,
                xlsx: 1
            }
            axios({
                url: '/token-transactions',
                method: 'GET',
                responseType: 'blob',
                params
            }).then((response) => {
                saveAs(response.data, 'transactions.xlsx');
            }).finally(() => {
                this.downloading = false;
            });
        }
    },
    mounted() {
        this.loadData();
        if (this.$auth.isAdmin()) {
            this.loadCompanies();
        }
    },
    beforeUnmount() {
        this.controller.companies && this.controller.companies.abort();
        this.controller.data && this.controller.data.abort();
    }
}

</script>
<template>
    <section class="token-transfers-index">

        <div class="my-4">
            <TokenTransactionsFilterPanel @change="onFiltersChange" :companies="companies">
                <template #buttons>
                    <b-button v-if="$auth.isAdmin()" :loading="downloading" type="is-link" icon-left="download" @click="downloadXlsx">
                        .xlsx
                    </b-button>
                </template>
            </TokenTransactionsFilterPanel>
        </div>

        <DownloadConfirmationsPanel
            @onChangeSelectionMode="onChangeSelectionMode"
            :selectionMode="selectionMode"
            :company-id="companyId"
            :filters="filters"
            :total="meta.total"
            :selectedIds="selectedIds"/>


        <TokenTransactionsTable
            v-if="transactions.length"
            :data="transactions"
            :selectionMode="selectionMode"
            :meta="meta"
            :loading="loading"
            :detailsView="true"
            storage-key="perPage_employerTransactions"
            @onToggleRow="onToggleRow"
            @onPageChange="onPageChange"
            @onPerPageChange="onPerPageChange"
        />

        <loader :loading="loading"/>

    </section>
</template>
